/* Library */
import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import commonUtil from '../../../../utils/commonUtil';
import InputButton from './../../../../components/ZUILib/InputButton';
import serverClientUtil from '../../../../utils/serverClientUtil';
import VozCliente from '../../../../components/VozCliente';
import { createTag } from '../../../../utils/googleTagManagerUtils';

const applicationRoutes = commonUtil.getApplicationRoutes();

const channel = commonUtil.getChannel();

class Entermytable extends Component {
  handleSearchGiftTableButtonClick = () => {
    this.props._handleRedirects(applicationRoutes.searchEvent);
  }

  handleCreateGiftTableButtonClick = () => {
    if (this.firstName === null || this.firstName === '') {
      this.handleLoginWithAuth0(`${window.location.origin}/crearevento/seleccioneeltipodemesa`);
    } else {
      createTag({
        event: 'mesa_regalos',
        phase: 'Banner Mesa de regalos',
        selection: 'Crear mesa de regalos',
        seccion: 'Mesa de Regalos',
      });
      this.openPageCreateEvent();
    }
  }

  openPageCreateEvent = () => {
    this.props._handleRedirects(applicationRoutes.mesaType);
  }
  constructor(props) {
    super(props);
    this.firstName = '';
  }
  hideErrorMsg = () => {
    this.errormsg.style.display = 'none';
    this.errormsg.innerHTML = '';
  }
  redirectToStatementPage = () => {
    browserHistory.push(applicationRoutes.downloadstatement);
  }

  handleLoginWithAuth0 = (redirectBackUrl) => {
    const url = serverClientUtil.getLPFullURL();
    const redirectUrl = 'https:' + url + '/login';
    window.location.replace(`${redirectUrl}?redirectAfterLoginHref=${redirectBackUrl}&originalRedirectHref=${window.location.origin}`);
  }

  render() {
    const searchEventButton = {
      type: 'button',
      value: 'Buscar una Mesa de Regalos',
      autoFocus: false,
      style: (channel === 'web') ? 'btnPrimary btnExtraLarge' : 'btnPrimary size-Full',
      onClickHandler: this.handleSearchGiftTableButtonClick,
    };

    const createEventButton = {
      type: 'button',
      value: 'Crear Mesa de Regalos',
      autoFocus: false,
      style: (channel === 'web') ? 'btnSecondary btnExtraLarge' : 'btnSecondary size-Full',
      onClickHandler: this.handleCreateGiftTableButtonClick,
    };
    const showMsg = commonUtil.readCookie('LoginStatus') || '';
    commonUtil.createCookie('LoginStatus', '', 0.02);
    this.firstName = this.props.user.loaded && this.props.user.data.result.firstName ? this.props.user.data.result.firstName : null;
    return (
      <React.Fragment>
        {this.props.hideWarningMessage ? null : (
          <React.Fragment>
            {this.firstName === null || showMsg === '' ? null : (
              <div className="alertWarning typeEventWarning" ref={errormsg => this.errormsg = errormsg} style={{ display: 'block' }}><i className="icon-alerta_amarilla" />
                <p>Este usuario no tiene una mesa de regalos registrada.</p><a className="icon-tache2" onClick={this.hideErrorMsg} >.</a>
              </div>
        )}
          </React.Fragment>
        )}
        <VozCliente page="home" />
        <div className="formBlock" id="loginForm">
          <InputButton buttonAttr={searchEventButton} />
          <InputButton buttonAttr={createEventButton} />
          {channel === 'web' ? <hr /> : null}
          {this.firstName === null ? <p className="inToMesa">¿Eres el festejado?&nbsp;
          <a className="intoMesaLabel" autoFocus="false" onClick={() => this.handleLoginWithAuth0(window.location.href)}>Entrar a mi mesa</a>
          </p> : null}
        </div>
      </React.Fragment>
    );
  }
}
export default Entermytable;
